import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Divider
} from '@mui/material';

const Terms = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4, minHeight: 'calc(100vh - 200px)' }}>
        <Paper sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Kullanım Koşulları
          </Typography>
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="body1" paragraph>
            Anılar Bulutta platformunu kullanarak, aşağıdaki kullanım koşullarını kabul etmiş sayılırsınız. Lütfen bu koşulları dikkatlice okuyunuz.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            1. Hizmet Kullanımı
          </Typography>
          <Typography variant="body1" paragraph>
            Anılar Bulutta, kullanıcıların etkinliklerinde fotoğraf ve video paylaşımını kolaylaştıran bir platformdur. Hizmetlerimizi kullanabilmek için 18 yaşından büyük olmanız veya ebeveyn/vasi gözetiminde olmanız gerekmektedir.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            2. Kullanıcı Hesabı
          </Typography>
          <Typography variant="body1" paragraph>
            Platformumuzu kullanmak için bir hesap oluşturmanız gerekmektedir. Hesap bilgilerinizin güvenliğinden siz sorumlusunuz ve hesabınızla gerçekleştirilen tüm etkinlikler sizin sorumluluğunuzdadır. Hesabınızla ilgili herhangi bir güvenlik ihlali durumunda derhal bizimle iletişime geçmelisiniz.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3. Kullanıcı İçeriği
          </Typography>
          <Typography variant="body1" paragraph>
            Platformumuza yüklediğiniz tüm içeriklerden (fotoğraflar, videolar vb.) siz sorumlusunuz. Bu içeriklerin telif hakkı size ait olmalı veya içeriği yükleme ve paylaşma hakkına sahip olmalısınız. Aşağıdaki türde içeriklerin yüklenmesi kesinlikle yasaktır:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Yasadışı, zararlı, tehditkar, taciz edici veya nefret içeren içerikler</li>
            <li>Başkalarının fikri mülkiyet haklarını ihlal eden içerikler</li>
            <li>Pornografik veya müstehcen içerikler</li>
            <li>Kötü amaçlı yazılım veya virüs içeren dosyalar</li>
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            4. Fikri Mülkiyet Hakları
          </Typography>
          <Typography variant="body1" paragraph>
            Anılar Bulutta platformu ve ilgili tüm içerikler (logo, tasarım, yazılım vb.) şirketimize aittir ve telif hakkı yasaları tarafından korunmaktadır. Platformumuza yüklediğiniz içeriklerin mülkiyet hakları size ait olmaya devam eder, ancak bu içerikleri hizmetlerimizi sağlamak amacıyla kullanma, kopyalama ve dağıtma hakkına sahip olduğumuzu kabul edersiniz.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            5. Hizmet Değişiklikleri ve Sonlandırma
          </Typography>
          <Typography variant="body1" paragraph>
            Anılar Bulutta, herhangi bir zamanda ve herhangi bir nedenle hizmetlerini değiştirme, askıya alma veya tamamen sonlandırma hakkını saklı tutar. Kullanım koşullarını ihlal etmeniz durumunda, hesabınızı askıya alma veya sonlandırma hakkımız bulunmaktadır.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            6. Sorumluluk Sınırlaması
          </Typography>
          <Typography variant="body1" paragraph>
            Anılar Bulutta, platformun kullanımından kaynaklanan doğrudan, dolaylı, arızi, özel veya cezai zararlardan sorumlu değildir. Platformumuz "olduğu gibi" sunulmaktadır ve herhangi bir garanti vermemekteyiz.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            7. Tazminat
          </Typography>
          <Typography variant="body1" paragraph>
            Kullanım koşullarını ihlal etmeniz veya platformumuzu uygunsuz şekilde kullanmanız durumunda, Anılar Bulutta'yı, yöneticilerini, çalışanlarını ve iş ortaklarını tüm iddia, zarar, yükümlülük ve masraflardan tazmin etmeyi kabul edersiniz.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            8. Geçerli Yasa ve Yargı Yetkisi
          </Typography>
          <Typography variant="body1" paragraph>
            Bu kullanım koşulları Türkiye Cumhuriyeti yasalarına tabidir ve bu yasalara göre yorumlanacaktır. Kullanım koşullarından kaynaklanan herhangi bir anlaşmazlık durumunda Türkiye Cumhuriyeti mahkemeleri yetkili olacaktır.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            9. Koşulların Değiştirilmesi
          </Typography>
          <Typography variant="body1" paragraph>
            Bu kullanım koşullarını herhangi bir zamanda değiştirme hakkını saklı tutarız. Değişiklikler, web sitemizde yayınlandıktan sonra geçerli olacaktır. Platformumuzu kullanmaya devam etmeniz, güncellenmiş koşulları kabul ettiğiniz anlamına gelir.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            10. İletişim
          </Typography>
          <Typography variant="body1" paragraph>
            Kullanım koşullarımızla ilgili sorularınız veya endişeleriniz varsa, lütfen bizimle iletişime geçin: info@anilarbulutta.com
          </Typography>
          
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
            Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Terms;